export const GET_ALL_SHOPS = "GET_ALL_SHOPS"
export const GET_ALL_SHOPS_RESPONSE_SUCCESS = "GET_ALL_SHOPS_RESPONSE_SUCCESS"
export const CREATE_SHOP = "CREATE_SHOP"
export const UPDATE_SHOP = "UPDATE_SHOP"
export const DELETE_SHOP = "DELETE_SHOP"
